import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import FilterService from "../../services/FilterService";
import { toast } from "react-toastify";
import "./EditFilter.css";

const EditFilterModal = ({ showModal, handleClose, filterData = {}, onFilterUpdated }) => {
  const [formData, setFormData] = useState({
    name: "",
    type: "",
    lastingDuration: "",
  });

  useEffect(() => {
    if (filterData && Object.keys(filterData).length > 0) {
      setFormData({
        name: filterData["Filter Name"] || "",
        type: filterData["Filter Code"] || "",
        lastingDuration: filterData["Lasting Duration (Months)"] || "",
      });
    }
  }, [filterData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const updateFilter = async () => {
    try {
      if (!filterData || !filterData.ID || Object.keys(filterData).length === 0) {
        throw new Error("Invalid filter data");
      }
      
      const payload = {
        filter_name: formData.name, 
        filter_code: formData.type,
        lasting_duration: parseInt(formData.lastingDuration), 
      };
  
      console.log("Payload sent to server for update:", payload); 
  
      // Call the update method in the service
      const response = await FilterService.update(filterData.ID, payload);
  
      toast.success(response?.data?.message || "Filter updated successfully", {
        autoClose: 2000,
      });
  
      // Reload the filters list and close modal
      onFilterUpdated();
      handleClose();
    } catch (error) {
      console.error("Failed to update filter:", error);
      const errorMessage = error.response?.data?.message || "Failed to update filter";
      toast.error(errorMessage);
    }
  };
  

  return (
    <Modal 
      className="edit-filter-modal" 
      show={showModal && filterData && Object.keys(filterData).length > 0} 
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title className="title">Edit Filter</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          <div className="form-group">
            <label>Filter Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Filter Name"
              required
            />
          </div>
          <div className="form-group">
            <label>Type</label>
            <input
              type="text"
              name="type"
              value={formData.type}
              onChange={handleInputChange}
              placeholder="Type"
              required
            />
          </div>
          <div className="form-group">
            <label>Lasting Duration (Months)</label>
            <input
              type="number"
              name="lastingDuration"
              value={formData.lastingDuration}
              onChange={handleInputChange}
              placeholder="Duration in Months"
              required
            />
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-end w-100">
          <Button variant="primary" onClick={updateFilter} className="w-100">
            Save
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default EditFilterModal;
